import { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Impact } from '@sorare/core/src/atoms/animations/Impact';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconHelpCircle } from '@sorare/core/src/atoms/icons/system/iconHelpCircle.ts';
import { iconTicket } from '@sorare/core/src/atoms/icons/system/iconTicket.ts';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelM, LabelS } from '@sorare/core/src/atoms/typography';
import { wheel } from '@sorare/core/src/lib/glossary';

import { HowToWinTicketDialog } from '#src/components/Wheel/HowToWinTicketDialog/index.tsx';

const Root = styled(Vertical).attrs({ center: true })`
  grid-area: tickets;
  width: 100%;
`;

type Props = {
  nb: number;
  rarity: Rarity;
};

export const Tickets = ({ nb, rarity }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <Root center>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage defaultMessage="Tickets" />
      </LabelM>
      <Impact trigger={nb}>
        <HeadlineL>
          <Horizontal>
            <FontAwesomeIcon icon={iconTicket} />
            <FormattedNumber value={nb} />
          </Horizontal>
        </HeadlineL>
      </Impact>
      {rarity !== Rarity.common && (
        <Button
          color="transparent"
          size="compact"
          onClick={() => setOpen(true)}
        >
          <LabelS color="var(--c-nd-500)">
            <Horizontal>
              <FontAwesomeIcon icon={iconHelpCircle} />
              <FormattedMessage {...wheel.howToWin} />
            </Horizontal>
          </LabelS>
        </Button>
      )}
      <HowToWinTicketDialog open={open} onClose={() => setOpen(false)} />
    </Root>
  );
};
